import './medimage.css';
import img from '../../assets/profile.png';
import { store } from '../../store/store';
import { useEffect, useState } from 'react';
import { RotatableImage } from '../RotatableImage/RotatableImage';
import { isAbsoluteUrl, normalizeImageUrl } from '../../utils/utils';

function MedImage({
  user_avatar = '',
  user_selfie = '',
  profileId = '',
}: {
  user_avatar: string;
  user_selfie: string;
  profileId?: string;
  loading?: boolean;
}) {
  // After a rotate is saved, reload the image. A cache-buster is only safe on a
  // relative (locally served) path; a presigned S3 URL is signed as-is and any
  // extra query param would invalidate it, so it is reused unchanged.
  const handleRotateSuccess = (setImage: React.Dispatch<React.SetStateAction<string>>, imagePath: string) => {
    if (!imagePath) return;
    if (isAbsoluteUrl(imagePath)) {
      setImage(imagePath);
      return;
    }
    setImage(`${normalizeImageUrl(imagePath)}?t=${new Date().getTime()}`);
  };

  // Состояния для хранения URL изображений
  const [avatarUrl, setAvatarUrl] = useState<string>('');

  const [selfieUrl, setSelfieUrl] = useState<string>('');

  useEffect(() => {
    setAvatarUrl(normalizeImageUrl(user_avatar));
    setSelfieUrl(normalizeImageUrl(user_selfie));
  }, [user_avatar, user_selfie]);

  return (
    <div className="medimage__container">
      <div className="image__card">
        <div className="status"></div>
        <div className="avatar-uploader">
          <RotatableImage
            imageUrl={avatarUrl}
            alt="Фото профиля"
            photoType="avatar"
            entityId={profileId}
            endpoint="/profiles"
            className="avatar-container"
            style={{ width: '100%', height: '100%' }}
            showControls={true}
            onRotateSuccess={() => handleRotateSuccess(setAvatarUrl, user_avatar)}
          />
        </div>
        <div className="role">Фото профиля</div>
      </div>

      <div className="image__card">
        <div className="status"></div>
        <div className="avatar-uploader">
          <RotatableImage
            imageUrl={selfieUrl}
            alt="Фото сейчас"
            photoType="selfie"
            entityId={profileId || ''}
            endpoint="/medlist"
            className="avatar-container"
            style={{ width: '100%', height: '100%' }}
            showControls={true}
            onRotateSuccess={() => handleRotateSuccess(setSelfieUrl, user_selfie)}
          />
        </div>
        <div className="role">Фото сейчас</div>
      </div>
    </div>
  );
}

export default MedImage;
